// Passed as `inputClass`/`buttonClassName` to RHFInput/RHFTextArea/RHFDatePicker
// so a hand-styled field matches RHFSelect's rendered look (rounded-lg,
// border-border-input, bg-background-form/40) instead of drifting per form —
// this file used to be copied into each form with small, silent variations
// (one had `border border-border-primary`, which overrides RHFInput's own
// `border-border-input` and is why a text field's border didn't match the
// dropdown beside it).
export const FORM_INPUT_STYLE =
  "w-full rounded-lg px-4 py-2.5 text-sm placeholder:text-text-muted bg-background-form/40 focus:outline-none transition text-text-primary";
